import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'datediff'
})
export class DatediffPipe implements PipeTransform {

  transform(endDate$?: Observable<Date>,startDate?: Date):  Observable<string> {

    return endDate$.pipe(
      map((endDate: Date) => {
        if(!startDate || !endDate){
          return "";
        }
        const differenceInSeconds = Math.floor((endDate.getTime() - startDate.getTime()) / 1000);        
        if (differenceInSeconds < 60) {
          return `${differenceInSeconds} seg.`;
        } else if (differenceInSeconds < 3600) {
          const minutes = Math.floor(differenceInSeconds / 60);
          const seconds = differenceInSeconds % 60;
          return `${minutes} min. ${seconds} seg.`;
        } else if (differenceInSeconds < 86400) {
          const hours = Math.floor(differenceInSeconds / 3600);
          const minutes = Math.floor((differenceInSeconds % 3600) / 60);
          const seconds = differenceInSeconds % 60;
          return `${hours} h. ${minutes} min. ${seconds} seg.`;
        } else {
          const days = Math.floor(differenceInSeconds / 86400);
          const hours = Math.floor((differenceInSeconds % 86400) / 3600);
          const minutes = Math.floor((differenceInSeconds % 3600) / 60);

          return `${days} d. ${hours} h. ${minutes} min.`;
        }
      }));
   
  }
}
